var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowingBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.467,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26724",
    transform: "translate(-389.127 -125.743)",
    fill: "none",
    stroke: "#185edf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4744",
    cx: 2.911,
    cy: 2.911,
    r: 2.911,
    transform: "translate(394.574 126.493)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4745",
    cx: 4.176,
    cy: 4.176,
    r: 4.176,
    transform: "translate(399.525 136.108)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16953",
    d: "M399.525 140.285a4.172 4.172 0 0 1 2.45-3.794 7.6 7.6 0 0 0-12.1 6.132h10.365a4.156 4.156 0 0 1-.715-2.338Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16954",
    d: "m403.435 138.819 1.465 1.465-1.465 1.465"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowingBlue);
export default __webpack_public_path__ + "static/media/FollowingBlue.cee304ad3c2d36a024648931d9104d14.svg";
export { ForwardRef as ReactComponent };